module.exports = __webpack_public_path__ + "img/VN-vip.e77f6ef6.png";